import React from 'react';

const CheckoutPageTimer = ({ pendingTime, isInValidTimer }) => {
  const message = !isInValidTimer ? `${pendingTime.time} remaining to complete` : "Time expired";
    return (
      <div className="map-page-timer">
        {message}
      </div>
    );
};

export default CheckoutPageTimer;



// WEBPACK FOOTER //
// ./src/components/checkout/CheckoutPageTimer.js